module.exports = __webpack_public_path__ + "img/コンピュータのしくみI_4_18_4.4b11ef62.jpeg";